<template>
    <div class="settings">
        <div class="content">
            <div class="wrapper">
                <div class="main-wrap">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane name="companies" :label="$t('settings_companies')">
                            <settingCompany @closeChat2="closeChat2" ref="settingCompany" />
                        </el-tab-pane>
                        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewOrganizationType" name="businessUnitTypes" :label="$t('settings_organization_type')">
                            <el-tabs v-model="activeOrganizationType" @tab-click="handleClick" class="my-table">
                                <el-tab-pane name="companyGeneral" :label="$t('settings_companyGeneral')">
                                    <settingCompanyGeneral ref="settingGeneral" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.companyAdditionalInfo" name="companyAdditionalInfo" :label="$t('settings_companyAdditionalInfo')">
                                    <settingCompanyAdditionalInfo ref="settingCompanyAdditionalInfo" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout && isPhilippines" :disabled="!companyLayout.permission.statutoryInformation" name="statutoryInformation" :label="$t('settings_statutoryInformation')">
                                    <settingCompanyStatutoryInformation ref="settingCompanyStatutoryInformation" />
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <!-- Company -->
                        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.companies" name="settingsCompany" :label="$t('settings_company')">
                            <el-tabs v-model="activeSettingsCompany" @tab-click="handleClick" class="my-table">
                                <el-tab-pane name="dataRooms" :label="$t('settings_accountThink_dataRooms')">

                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewGlAccounts" name="glAccount" :label="$t('settings_accountThink_GLAccounts')">
                                    <setting-g-l-accounts2 ref="glAccount"/>
<!--                                  <settingGLAccounts ref="glAccount"/>-->
                                </el-tab-pane>
                                <el-tab-pane name="compliance" :label="$t('settings_accountThink_compliance')">
                                    <el-tabs class="my-table">
                                      <el-tab-pane name="statutory" :label="$t('settings_accountThink_statutory')">

                                      </el-tab-pane>

                                      <el-tab-pane name="regulatory" :label="$t('settings_accountThink_regulatory')">

                                      </el-tab-pane>

                                      <el-tab-pane name="taxation" :label="$t('settings_accountThink_taxation')">

                                      </el-tab-pane>
                                    </el-tabs>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewBusinessCenters" name="BusinessCenters" :label="$t('settings_businessCenters')">
                                    <BusinessCenters ref="BusinessCenters"/>
                                </el-tab-pane>
                                <el-tab-pane name="BusinessUnits" :label="$t('settings_businessUnits')">
                                    <BusinessUnits ref="BusinessUnits"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewInventory" name="inventory" :label="$t('settings_accountThink_inventory')">
                                    <inventory ref="inventory" />
                                </el-tab-pane>
                                <!--<el-tab-pane name="engagements" :label="$t('settings_engagements')">-->
                                    <!--<settingEngagements ref="engagements" />-->
                                <!--</el-tab-pane>-->
                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewEngagementStages" name="engagementStages" :label="$t('settings_engagementStages')">
                                    <settingEngagementStages ref="engagementStages" />
                                </el-tab-pane> -->
                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewProjectPhases" name="companyStages" :label="$t('settings_projectPhases')">
                                    <settingCompanyPhases ref="companyStages" />
                                </el-tab-pane> -->

                                <!-- v-if="companyLayout" :disabled="!companyLayout.permission.viewEngagementStages" -->
                                <el-tab-pane name="engagementTypes" :label="$t('settings_engagementTypes')">
                                    <engagementTypes ref="engagementTypes"/>
                                </el-tab-pane>
                                <!-- v-if="companyLayout" :disabled="!companyLayout.permission.viewProjectPhases" -->
                                <el-tab-pane name="projectTypes" :label="$t('settings_projectTypes')">
                                    <projectTypes ref="projectTypes"/>
                                </el-tab-pane>

                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewRegions" :name="$t('settings_regions')" :label="$t('settings_regions')">
                                    <Regions ref="Regions"/>
                                </el-tab-pane>

                                <el-tab-pane name="progressBilling" :label="$t('settings_progress_notes')">
                                    <ProgressBilling ref="progressBilling"/>
                                </el-tab-pane>

                                <el-tab-pane name="companyCategories" :label="$t('settings_categories')">
                                    <settingCompanyCategories ref="companyCategories" />
                                </el-tab-pane>
                                <el-tab-pane name="companyClassifications" :label="$t('settings_classifications')">
                                    <settingCompanyClassifications ref="companyClassifications" />
                                </el-tab-pane>
                                <!-- <el-tab-pane name="companyChartOfAccountItems" label="Chart Of Account">
                                    <settingChartOfAccount ref="companyChartOfAccountItems" />
                                </el-tab-pane> -->
                                <el-tab-pane name="reports" :label="$t('settings_accountThink_reports')">

                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewPermissionsPressets" name="settingsPermissions" :label="$t('settings_permissions')">
                            <el-tabs v-model="activeSettingsPermissions" @tab-click="handleClick" class="my-table">
                                <!--<el-tab-pane name="Permissions" label="Permissions">-->
                                    <!--<settingPermissions/>-->
                                <!--</el-tab-pane>-->
                                <!--<el-tab-pane name="permissions2" label="Permissions">-->
                                    <!--<settingPermissions2 ref="settingPermissions2"/>-->
                                <!--</el-tab-pane>-->
                                <el-tab-pane name="companyPermissions" :label="$t('general_company')">
                                    <companyPermissions ref="companyPermissions"/>
                                </el-tab-pane>
                                <el-tab-pane name="businessUnitsPermissions" :label="$t('settings_permissions_businessUnits')">
                                    <businessUnitPermissions ref="businessUnitPermissions"/>
                                </el-tab-pane>
                                <el-tab-pane name="engagementsPermissions" :label="$t('settings_permissions_engagements')">
                                    <engagementPermissions ref="engagementPermissions"/>
                                </el-tab-pane>
                                <el-tab-pane name="projectsPermissions" :label="$t('settings_permissions_projects')">
                                    <projectPermissions ref="projectPermissions"/>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewDocumentManagment" name="documentManagment" :label="$t('settings_ducument_managment')">
                            <el-tabs v-model="activeDucumentManagment" @tab-click="handleClick" class="my-table">
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewSop" name="sop" :label="$t('settings_ducument_managment_sop')">
                                    <sop ref="sop"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewPolicy" name="policy" :label="$t('settings_ducument_managment_policy')">
                                    <policy ref="policy"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewHealthSafety" name="healthSafety" :label="$t('settings_ducument_managment_healthSafety')">
                                    <healthSafety ref="healthSafety"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewRiskAssesment" name="riskAssesment" :label="$t('settings_ducument_managment_commercial')">
                                    <riskAssesment ref="riskAssesment"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewEnvirenmental" name="envirenmental" :label="$t('settings_ducument_managment_general')">
                                    <envirenmental ref="envirenmental"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewStatus" name="status" :label="$t('settings_ducument_managment_status')">
                                  <status ref="status"/>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane name="settingsEmailManagment" :label="$t('settings_email_managment')">
                            <el-tabs v-model="activeEmailManagment" @tab-click="handleClick" class="my-table">
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewCompanyMailTemplates" name="mailTemplate" :label="$t('settings_email_managment_mailTemplate')">
                                    <mailTemplate ref="mailTemplate"/>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <!-- <el-tab-pane name="projectTaskProgressActivities" :label="$t('settings_progress_notes')">
                            <el-tabs v-model="activeProgressNotesTab" @tab-click="handleClick" class="my-table">
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewAssignments" name="projectTaskProgressAssignments" :label="$t('settings_progress_notes_assignments')">
                                    <settingTable ref="projectTaskProgressAssignments" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewActivities" name="projectTaskProgressActivities" :label="$t('settings_progress_notes_activities')">
                                    <settingTable ref="projectTaskProgressActivities" />
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane> -->
                        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewAccountThink" name="accountTHINK" :label="$t('settings_accountThink')">
                            <el-tabs name="projectTaskExpenseCategories" v-model="accountTHINGTab" @tab-click="handleClick" class="my-table">
                                <!--<el-tab-pane name="companyChartOfAccountItems" label="Chart of Accounts">-->
                                    <!--<settingChartOfAccount ref="companyChartOfAccountItems" />-->
                                <!--</el-tab-pane>-->
                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewGlAccounts" name="glAccount" :label="$t('settings_accountThink_GLAccounts')">
                                    <settingGLAccounts ref="glAccount"/>
                                </el-tab-pane> -->

                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewGlAccountGroups" name="glAccountGroups" :label="$t('settings_accountThink_GLAccountGroups')">
                                    <settingGLAccountGroups ref="glAccountGroups"/>
                                </el-tab-pane> -->
                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewGlAccountClasses" name="glAccountClasses" :label="$t('settings_accountThink_GLAccountClasses')">
                                    <settingGLAccountClasses ref="glAccountClasses"/>
                                </el-tab-pane> -->

                                <!--<el-tab-pane name="projectTaskExpenseCategories" label="Expense Category">-->
                                    <!--<settingTable ref="projectTaskExpenseCategories" />-->
                                <!--</el-tab-pane>-->
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewPaymentMethods" name="projectTaskExpsensePaymentMethods" :label="$t('settings_accountThink_paymentMethods')">
                                    <settingTableForPaymentMethods ref="projectTaskExpsensePaymentMethods" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewTaxTypes" name="projectTaxes" :label="$t('settings_accountThink_taxTypes')">
                                    <settingTaxes ref="projectTaxes" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewUnits" name="units" :label="$t('settings_accountThink_units')">
                                    <units ref="units" />
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewItemsType" name="companyInventoryItems" :label="$t('settings_accountThink_itemsTypes')">
                                    <!-- <settingType ref="companyInventoryItems" /> -->
                                    <items ref="companyInventoryItems"/>
                                </el-tab-pane>
                                <el-tab-pane name="creditCardsAccounts" label="Credit Cards Accounts">
                                    <settings-credit-card-accounts ref="creditCardsAccounts"/>
                                </el-tab-pane>
                              <el-tab-pane name="bankAccounts" :label="$t('settings_accountThink_bankAccounts')">
                                    <settings-bank-accounts ref="bankAccounts"/>
                                </el-tab-pane>
                              <el-tab-pane v-if="companyLayout" name="taxAccounts" :label="$t('settings_accountThink_taxAccounts')">
                                <setting-account-taxes ref="accountTaxes"/>
                              </el-tab-pane>
                                <!-- <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewInventory" name="inventory" :label="$t('settings_accountThink_inventory')">
                                    <inventory ref="inventory" />
                                </el-tab-pane> -->
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane name="settingsTaskTreeTamplates" :label="$t('settings_taskTreeTamplates')">
                            <el-tabs v-model="accountTaskTreeTamplates" class="my-table" @tab-click="handleClick">
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewBusinessUnitTemplates" name="businessUnitTemplates" :label="$t('settings_taskTreeTamplates_businessUnitTemplates')">
                                    <BusinessUnitTemplates ref="businessUnitTemplates"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewEngagementTemplates" name="engagementTemplates" :label="$t('settings_taskTreeTamplates_engagementTemplates')">
                                    <EngagementTemplates ref="engagementTemplates"/>
                                </el-tab-pane>
                                <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewProjectTemplates" name="projectTemplates" :label="$t('settings_taskTreeTamplates_projectTemplates')">
                                    <ProjectTemplates ref="projectTemplates"/>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane name="humanCapitalManagement" :label="$t('settings_humanCapitalManagement')">
                            <el-tabs v-model="humanCapitalManagement" class="my-table" @tab-click="handleClick">
                                <el-tab-pane name="humanCapitalManagementPeriodsTab" :label="$t('settings_humanCapitalManagement_periods')">
                                    <human-capital-management-periods-tab ref="humanCapitalManagementPeriodsTab"/>
                                </el-tab-pane>
                                <el-tab-pane name="humanCapitalManagementItemsTab" :label="$t('settings_humanCapitalManagement_items')">
                                    <human-capital-management-items-tab
                                            ref="humanCapitalManagementItemsTab"/>
                                </el-tab-pane>
                                <el-tab-pane name="timeKeeping" :label="$t('settings_humanCapitalManagement_timeKeeping')">
                                    <time-keeping-tab
                                            ref="timeKeeping"
                                            v-model="timeKeepingActiveTab"/>
                                </el-tab-pane>

                                <el-tab-pane name="leaveManagement" :label="$t('settings_humanCapitalManagement_leaveManagement')">

                                </el-tab-pane>
                                <el-tab-pane  name="payRun" :label="$t('settings_humanCapitalManagement_payRun')">

                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
<!--                        <el-tab-pane :label="$t('settings_subscriptions')" name="settingsSubscriptions">-->
<!--                            <settings-subscriptions ref="settingsSubscriptions"/>-->
<!--                        </el-tab-pane>-->
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import settingCompany from '@/components/settings/settingCompany'
  import settingTable from '@/components/settings/settingTable'
  import settingTaxes from '@/components/settings/settingTaxes'
  import settingType from '@/components/settings/settingType'
  import items from '@/components/settings/items/items'
  import settingTableForPaymentMethods from '@/components/settings/settingTableForPaymentMethods'
  import settingBusinessUnitTypes from '@/components/settings/settingBusinessUnitTypes'
  import settingCompanyPhases from '@/components/settings/settingCompanyPhases'
  import settingEngagementStages from '@/components/settings/settingEngagementStages'

  import settingCompanyGeneral from '@/components/settings/settingCompanyGeneral'
  import settingCompanyAdditionalInfo from '@/components/settings/settingCompanyAdditionalInfo'
  import settingCompanyStatutoryInformation from '@/components/settings/settingCompanyStatutoryInformation'
  import settingChartOfAccount from '@/components/settings/settingChartOfAccount'
  import settingGLAccountClasses from '@/components/settings/settingGLAccountClasses'
  import settingGLAccountGroups from '@/components/settings/settingGLAccountGroups'
  import settingGLAccounts from '@/components/settings/settingGLAccounts'
  import settingEngagements from '@/components/settings/settingEngagements'
  import settingPermissions from '@/components/settings/settingPermissions'
  import settingPermissions2 from '@/components/settings/settingPermissions2'
  import BusinessUnitTemplates from '@/components/settings/taskTree/BusinessUnitTemplates'
  import EngagementTemplates from '@/components/settings/taskTree/EngagementTemplates'
  import ProjectTemplates from '@/components/settings/taskTree/ProjectTemplates'
  import settingCompanyCategories from '@/components/settings/settingCompanyCategories'
  import settingCompanyClassifications from '@/components/settings/settingCompanyClassifications'

  // accountTHINK
  import units from '@/components/settings/accountTHINK/Units'
  import inventory from '@/components/settings/accountTHINK/Inventory'

  // company
  import BusinessCenters from '@/components/settings/company/BusinessCenters'
  import BusinessUnits from '@/components/settings/company/BusinessUnits'
  import Regions from '@/components/settings/company/Regions'
  import engagementTypes from '@/components/settings/company/engagementTypes'
  import projectTypes from '@/components/settings/company/projectTypes'

  // documentManagment
  import sop from '@/components/settings/documentManagment/sop'
  import policy from '@/components/settings/documentManagment/policy'
  import healthSafety from '@/components/settings/documentManagment/healthSafety'
  import riskAssesment from '@/components/settings/documentManagment/riskAssesment'
  import envirenmental from '@/components/settings/documentManagment/envirenmental'
  import status from '@/components/settings/documentManagment/status'

  // Permissions
  import companyPermissions from '@/components/settings/permissions/companyPermissions'
  import projectPermissions from '@/components/settings/permissions/projectPermissions'
  import businessUnitPermissions from '@/components/settings/permissions/businessUnitPermissions'
  import engagementPermissions from '@/components/settings/permissions/engagementPermissions'
  // import SettingsSubscriptions from "../components/users/settingsSubscriptions";

  // Email Managment
  import mailTemplate from '@/components/settings/emailManagment/mailTemplate'
  import TimeKeepingTab from "../components/settings/humanCapitalManagement/TimeKeepingTab";
  import HumanCapitalManagementItemsTab from "../components/settings/humanCapitalManagement/ItemsTab";
  import HumanCapitalManagementPeriodsTab from "../components/settings/humanCapitalManagement/PeriodsTab";

  import ProgressBilling from '@/components/settings/od/ProgressBilling';
  import SettingGLAccounts2 from "../components/settings/settingGLAccounts2";
  import SettingAccountTaxes from "../components/settings/settingAccountTaxes";
  import SettingsBankAccounts from "../components/settings/settingsBankAccounts/settingsBankAccounts";
  import SettingsCreditCardAccounts from "../components/settings/settingsCreditCardAccounts/settingsCreditCardAccounts";

  export default {
    name: 'settings',
    components: {
      SettingsCreditCardAccounts,
      SettingsBankAccounts,
      SettingAccountTaxes,
      SettingGLAccounts2,
      engagementTypes,
      projectTypes,
      HumanCapitalManagementPeriodsTab,
      HumanCapitalManagementItemsTab,
      TimeKeepingTab,
      // SettingsSubscriptions,
      // Header,
      // Menu,
      settingCompany,
      settingTable,
      settingTaxes,
      settingType,
      settingCompanyGeneral,
      settingCompanyAdditionalInfo,
      settingCompanyStatutoryInformation,
      settingTableForPaymentMethods,
      settingBusinessUnitTypes,
      settingCompanyCategories,
      settingCompanyClassifications,
      settingCompanyPhases,
      settingEngagementStages,
      settingChartOfAccount,
      settingGLAccountGroups,
      settingGLAccounts,
      settingGLAccountClasses,
      settingEngagements,
      settingPermissions,
      settingPermissions2,
      ProjectTemplates,
      EngagementTemplates,
      BusinessUnitTemplates,
      //company
      BusinessCenters,
      BusinessUnits,
      Regions,
      sop,
      policy,
      healthSafety,
      riskAssesment,
      envirenmental,
      status,
      units,
      inventory,
      companyPermissions,
      projectPermissions,
      businessUnitPermissions,
      engagementPermissions,
      mailTemplate,
      ProgressBilling,
      items,
    },
    created() {
      if (this.$route.query.at) {
        this.activeName = 'accountTHINK'
      }

      if (this.$route.query.items) {
        this.activeName = 'accountTHINK'
        this.accountTHINGTab = 'companyInventoryItems'
      }

      if (this.$route.query.coa) {
        this.activeName = 'settingsCompany'
        this.activeSettingsCompany = 'glAccount'
      }

      if (this.$route.query.bankAccounts) {
        this.activeName = 'accountTHINK'
        this.accountTHINGTab = 'bankAccounts'
      }

      if (this.$route.query.creditCardsAccounts) {
        this.activeName = 'accountTHINK'
        this.accountTHINGTab = 'creditCardsAccounts'
      }
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mounted(){
      if (this.activeName === 'settingsCompany' && this.activeSettingsCompany === 'glAccount') {
        this.handleClick({name:'glAccount'})
      }
      if (this.activeName === 'accountTHINK' && this.accountTHINGTab === 'companyChartOfAccountItems') {
        this.handleClick({name:'companyChartOfAccountItems'})
      }
      if (this.activeName === 'accountTHINK' && this.accountTHINGTab === 'companyInventoryItems') {
        this.handleClick({name:'companyInventoryItems'})
      }
      if (this.activeName === 'accountTHINK' && this.accountTHINGTab === 'bankAccounts') {
        this.handleClick({name:'bankAccounts'})
      }
      if (this.activeName === 'accountTHINK' && this.accountTHINGTab === 'creditCardsAccounts') {
        this.handleClick({name:'creditCardsAccounts'})
      }
    },
    data() {
      return {
        isPhilippines: false,
        activeName: 'companies',
        activeCompany:{},
        activeOrganizationType: 'companyGeneral',
        activeSettingsCompany: 'dataRooms',
        activeSettingsPermissions: 'companyPermissions',
        activeDucumentManagment: 'sop',
        activeEmailManagment: 'mailTemplate',
        accountTaskTreeTamplates: 'businessUnitTemplates',
        humanCapitalManagement: 'humanCapitalManagementItemsTab',
        timeKeepingActiveTab: 'schedules',
        activeProgressNotesTab: 'projectTaskProgressActivities',
        accountTHINGTab: 'projectTaskExpsensePaymentMethods',
        // companyNameSelect: '',
        // open: false,
        refresfTable: true
      }
    },
    methods: {
      handleMainClick(){

      },
      isPhilippinesCheck() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/companies/directoriesCompanyAdditionalInfo?companyId=${this.$route.query.companyId}`)
          .then(response => {
            // console.log('lolololo', response.data)
            this.isPhilippines = response.data.data.isPhilippines
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      handleClick(tab, event) {
        if(tab.name === 'projectTaskExpenseCategories'){
          this.$refs['projectTaskExpenseCategories'].loadList(tab.name)
        }else if(tab.name === 'projectTaskProgressActivities'){
          this.$refs['projectTaskProgressActivities'].loadList(tab.name)
        }else if(tab.name === 'projectTaskProgressAssignments'){
          this.$refs['projectTaskProgressAssignments'].loadList(tab.name)
        }else if(tab.name === 'projectTaskExpsensePaymentMethods'){
          this.$refs['projectTaskExpsensePaymentMethods'].loadList(tab.name)
        }else if(tab.name === 'projectTaxes'){
          this.$refs['projectTaxes'].loadList()
        }else if (tab.name === 'taxAccounts') {
          this.$refs['accountTaxes'].loadList()
        }else if (tab.name === 'bankAccounts') {
          this.$refs['bankAccounts'].loadList()
        }else if (tab.name === 'creditCardsAccounts') {
          this.$refs['creditCardsAccounts'].loadList()
        }else if(tab.name === 'companyInventoryItems'){
          // this.$refs['companyInventoryItems'].loadList(tab.name)
          this.$refs['companyInventoryItems'].loadFirstTab()
        }else if(tab.name === 'businessUnitTypes'){
          this.isPhilippinesCheck();
          // this.$refs['businessUnitTypes'].loadList(tab.name)
          // this.checkAdditionInfo(this.$route.query.companyId)
          // this.$refs['settingCompanyAdditionalInfo'].getCompanyAditionalInfo(tab.name)
          this.$refs['settingGeneral'].getCompanyGeneral(tab.name)
        }else if(tab.name === 'companyAdditionalInfo'){
          this.$refs['settingCompanyAdditionalInfo'].getCompanyAditionalInfo(tab.name)
        }else if(tab.name === 'statutoryInformation'){
          this.$refs['settingCompanyStatutoryInformation'].getCompanyAditionalInfo(tab.name)
        }else if(tab.name === 'engagements'){
          this.$refs['engagements'].loadList(tab.name)
        }else if(tab.name === 'engagementStages'){
          this.$refs['engagementStages'].loadList(tab.name)
        }else if(tab.name === 'companyStages'){
          this.$refs['companyStages'].loadList(tab.name)
        }else if(tab.name === 'companyCategories'){
          this.$refs['companyCategories'].loadList(tab.name)
        }else if(tab.name === 'companyClassifications'){
          this.$refs['companyClassifications'].loadList(tab.name)
        }else if(tab.name === 'companyChartOfAccountItems'){
          this.$refs['companyChartOfAccountItems'].loadList()
        }else if(tab.name === 'glAccount'){

          this.$refs['glAccount'].loadCompanyInfo()
          this.$refs['glAccount'].loadList()
        }else if(tab.name === 'glAccountGroups'){
          this.$refs['glAccountGroups'].loadList()
        }else if(tab.name === 'glAccountClasses'){
          this.$refs['glAccountClasses'].loadList()
        }else if(tab.name === 'projectTemplates'){
          this.$refs['projectTemplates'].loadList()
        }else if(tab.name === 'businessUnitTemplates'){
          this.$refs['businessUnitTemplates'].loadList()
        }else if(tab.name === 'engagementTemplates'){
          this.$refs['engagementTemplates'].loadList()
        }else if(tab.name === 'BusinessCenters'){
          this.$refs['BusinessCenters'].loadList()
        }else if(tab.name === 'BusinessUnits'){
          this.$refs['BusinessUnits'].loadList()
        }else if(tab.name === 'Regions'){
          this.$refs['Regions'].loadList()
        } else if(tab.name === 'Permissions') {
          // this.$router.push({ path: 'permissions', query: { companyId: this.$route.query.companyId } })
        }else if(tab.name === 'sop'){
          this.$refs['sop'].loadList()
        }else if(tab.name === 'policy'){
          this.$refs['policy'].loadList()
        }else if(tab.name === 'healthSafety'){
          this.$refs['healthSafety'].loadList()
        }else if(tab.name === 'riskAssesment'){
          this.$refs['riskAssesment'].loadList()
        }else if(tab.name === 'envirenmental'){
          this.$refs['envirenmental'].loadList()
        }else if(tab.name === 'status'){
          this.$refs['status'].loadList()
        }else if(tab.name === 'units'){
          this.$refs['units'].loadList()
        }else if(tab.name === 'inventory'){
          this.$refs['inventory'].loadList()
        }else if(tab.name === 'companyPermissions'){
          this.$refs['companyPermissions'].loadProjectPermissionsList()
        }else if(tab.name === 'projectsPermissions'){
          this.$refs['projectPermissions'].loadProjectPermissionsList()
        }else if(tab.name === 'businessUnitsPermissions'){
          this.$refs['businessUnitPermissions'].loadProjectPermissionsList()
        }else if(tab.name === 'engagementsPermissions'){
          this.$refs['engagementPermissions'].loadProjectPermissionsList()
        } else if (tab.name === 'mailTemplate') {
          this.$refs['mailTemplate'].loadList()
        } else if (tab.name === 'settingsCompany') {
          // this.$refs['BusinessCenters'].loadList()
        } else if (tab.name === 'settingsPermissions') {
          this.$refs['companyPermissions'].loadProjectPermissionsList()
        } else if (tab.name === 'documentManagment') {
          this.$refs['sop'].loadList()
        } else if (tab.name === 'settingsEmailManagment') {
          this.$refs['mailTemplate'].loadList()
        } else if (tab.name === 'accountTHINK') {
          // this.$refs['glAccount'].loadList()
          this.$refs['projectTaskExpsensePaymentMethods'].loadList('projectTaskExpsensePaymentMethods')
        } else if (tab.name === 'settingsTaskTreeTamplates') {
          this.$refs['businessUnitTemplates'].loadList()
        } else if (tab.name === 'humanCapitalManagement') {
          this.$refs[this.humanCapitalManagement].loadList()
        }else if (tab.name === 'humanCapitalManagementItemsTab') {
          this.$refs.humanCapitalManagementItemsTab.loadList()
        } else if (tab.name === 'timeKeeping') {
          this.$refs.timeKeeping.loadList()
        } else if (tab.name === 'humanCapitalManagementPeriodsTab') {
          this.$refs.humanCapitalManagementPeriodsTab.loadList()
        } else if (tab.name === 'engagementTypes') {
          this.$refs.engagementTypes.loadList()
        } else if (tab.name === 'projectTypes') {
          this.$refs.projectTypes.loadList()
        }else if(tab.name === 'companyGeneral'){
          this.$refs['settingGeneral'].getCompanyGeneral(tab.name)
        } else if (tab.name === 'progressBilling') {
          this.$refs['progressBilling'].loadFirstTab()
        }
      },
      checkAdditionInfo(companyId){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/companies/item?companyId=${companyId}`)
          .then(response => {
            this.activeCompany = response.data.item;
            console.log('activeCompany', response.data.item);
            loader.hide()
          }).catch(err => {
          loader.hide()
        })
      },
      // openDialog(){
      //   this.$emit('openChat2')
      // },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      openDialog(){
        this.$emit('openChat2')
      },
      closeChat2(){
        this.$emit('closeChat2')
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      // companyName(name) {
      //   console.log('companyNameInsettings', name)
      //   this.companyNameSelect = name
      // }
    },
    watch:{
      $route(to, from) {
        // react to route changes...
        // eslint-disable-next-line no-console
        console.log('from', from)
        if (from.query.at) {
          this.activeName = 'accountTHINK'
          this.accountTHINGTab = 'glAccount'
        } else if (from.query.coa) {
          this.activeName = 'accountTHINK'
          this.accountTHINGTab = 'glAccount'
        } else if (from.query.bankAccounts) {
          this.activeName = 'accountTHINK'
          this.accountTHINGTab = 'bankAccounts'
        } else if (from.query.creditCardsAccounts) {
          this.activeName = 'accountTHINK'
          this.accountTHINGTab = 'creditCardsAccounts'
        } else {
          this.activeName = 'companies'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .settings{
        background: #DfE8F0;
        // height: 100vh;
    }
    .content {
        display: flex;
        min-height: 100vh;
        padding-top: 50px;
        .wrapper{
            background: #fff;
            margin: 10px 10px 10px 10px;
            width:100%;
            display:flex;
            justify-content:center;
            .main-wrap{
                padding-top: 20px;
                width:100%;
                max-width:1500px;
            }
            &.animation{
                margin-left:260px;
                transition: margin-left 500ms ease-out, transform 500ms ease-out;
            }
        }
    }
    .my-table{
        height:100% !important;
    }
    .menu{
        min-height:calc(100vh - 50px);
    }
    .menu.animation{
        position: fixed;
    }
</style>

<style>

</style>
